
import React, { useState } from 'react';
import $ from 'jquery';
import axios from 'axios';
import DeviceDealerForm from './DeviceDealerForm';
import FpsDetailsForm from './FpsDetailsForm';
import Fps_details_update from './Fps_details_update';
import CircularProgress from '@mui/material/CircularProgress';


const Device_Dealer_Interface = () => {
  const [fpsId, setFpsId] = useState('');
  const [currentView, setCurrentView] = useState('main'); 
  const [data, setData] = useState({ list: [], check: 0, fps_id: '', terminal_id: '', fps_name: '', district: '', fps_maintain_by: '' });
  const [successData, setSuccessData] = useState(null);
  const [restoredFormData, setRestoredFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const detailsF = async (id) => {
    var fps_id = id;
    if (!fps_id) {
      alert("Please Fill FPS ID");
      document.getElementById('fps_id').focus();
      document.getElementById('fps_id').style.border = "1px solid red";
      return false;
    }

    setData({ list: [], check: 0, fps_id: '', terminal_id: '', fps_name: '', district: '', fps_maintain_by: '' });
    setRestoredFormData(null);
    setError(''); 
    setCurrentView('main');
    setLoading(true);
    
    setTimeout(() => {
      $('html, body').animate({
        scrollTop: $("#detailsF").offset()?.top || 0
      }, 2000);
    }, 1000);
    
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL}/api/fps-details/${fps_id}`, { withCredentials: true });
      if (res.data.message === "Session Expired") {
      alert("Session Expired");
      setLoading(false);
      setCurrentView('main');
      setFpsId('');
      return false;
    }
      setData(res.data);
      setFpsId(fps_id);
      setCurrentView('details');
      setLoading(false);
    } catch (err) {
      setLoading(false);
      const errorMessage = err.response?.data?.message || 'Internal Exception';
      setError(errorMessage);
      setCurrentView('main');
    }
    return false;
  };

  const handleBackToMain = () => {
    setCurrentView('main');
    // Clear everything including FPS ID when going back from success page
    setFpsId('');
    setData({ list: [], check: 0, fps_id: '', terminal_id: '', fps_name: '', district: '', fps_maintain_by: '' });
    setRestoredFormData(null);
    setSuccessData(null);
    setError('');
  };

  const handleShowSuccess = (showData) => {
    setRestoredFormData(showData.formData);
    setSuccessData(showData.response);
    setCurrentView('success');
  };

  React.useEffect(() => {
    const handlePopState = () => {
      if (currentView === 'success') {
        setCurrentView('details');
      } else if (currentView === 'details') {
        setCurrentView('main');
        setFpsId('');
        setRestoredFormData(null);
        setSuccessData(null);
        setError('');
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [currentView]);

  return (
    <div id="wrapper">
      <div className="wrapper row3">
        <div id="container">
          <div align="center">
            {currentView !== 'success' && (
              <>
                <DeviceDealerForm
                  onSubmit={detailsF}
                  fpsId={fpsId} // This will be empty when coming back from success page
                />
                {error && currentView === 'main' && (
                  <div style={{ 
                    color: 'red', 
                    textAlign: 'center', 
                    margin: '10px 0', 
                    fontSize: '16px',
                    fontWeight: 'bold'
                  }}>
                    {error}
                  </div>
                )}
              </>
            )}
            
            <div align="center" id="loading" style={{ display: loading ? 'block' : 'none' }}>
              <CircularProgress />
            </div>
            
            <br />
            
            {currentView === 'details' && (
              <div id="detailsF">
                <FpsDetailsForm
                  data={data}
                  fpsId={fpsId}
                  restoredFormData={restoredFormData}
                  setRestoredFormData={setRestoredFormData}
                  setShowSuccess={handleShowSuccess}
                  setSuccessData={setSuccessData}
                  setShowDetailsF={() => setCurrentView('details')}
                  onBack={handleBackToMain}
                />
              </div>
            )}
            
            {currentView === 'success' && (
              <Fps_details_update data={successData} onBack={handleBackToMain} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Device_Dealer_Interface;